import React from 'react'

export default function ErrorMessage({ messages }) {
    return (
        <span style={{ color: 'red' }}>
            {messages[0]}
        </span>
    )
}
